import React from 'react'
import { AppProvider } from "../contexts/AppContext";
import Map from "../components/Map/Map";
import UI from "../components/UI";
import LoadScreen from "../components/UI/LoadScreen/LoadScreen";

/**
 * Renders a Regional Map based on the path selected in the URL, can be ecowas or sadc etc.
 *
 * @return {JSX.Element} The rendered RegionalMap component.
 */
export default function RegionalMap() {
  return <LoadScreen
    component={
      <AppProvider>
        <UI />
        <Map />
      </AppProvider>
    }
  />
}
